import { render, staticRenderFns } from "./IzinUsahaJasaViewNew.vue?vue&type=template&id=0960f66a&scoped=true&lang=pug&"
import script from "./IzinUsahaJasaViewNew.vue?vue&type=script&lang=js&"
export * from "./IzinUsahaJasaViewNew.vue?vue&type=script&lang=js&"
import style0 from "./IzinUsahaJasaViewNew.vue?vue&type=style&index=0&id=0960f66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960f66a",
  null
  
)

export default component.exports